module.exports = __webpack_public_path__ + "img/currency-yen-circle.ff919ba3.svg";